import React, { useState } from 'react';
import { superApi } from './SuperAdminAuth';
import { toast } from 'sonner';
import { Megaphone, Send } from 'lucide-react';

export const SuperBroadcastPage = () => {
  const [subject, setSubject] = useState('');
  const [html, setHtml] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const send = async () => {
    if (!subject || !html) return toast.error('Subject and body are required');
    if (!window.confirm('Send this email to ALL tenant admins?')) return;
    setSending(true);
    try {
      const r = await superApi.post('/super/email/broadcast', { subject, html });
      setResult(r.data);
      toast.success(`Sent to ${r.data.sent}/${r.data.total} admins`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="p-8 max-w-3xl mx-auto">
      <div className="mb-6 flex items-center gap-2">
        <Megaphone className="w-6 h-6 text-amber-400" />
        <h1 className="text-2xl font-semibold text-white">Broadcast to All Tenants</h1>
      </div>
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 space-y-4">
        <div>
          <label className="text-xs text-slate-400 uppercase tracking-wider">Subject</label>
          <input value={subject} onChange={(e) => setSubject(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-lg bg-slate-950 border border-slate-800 text-white focus:outline-none focus:border-amber-500/50" />
        </div>
        <div>
          <label className="text-xs text-slate-400 uppercase tracking-wider">HTML Body</label>
          <textarea rows={12} value={html} onChange={(e) => setHtml(e.target.value)} placeholder="<p>Hi team…</p>" className="w-full mt-1 px-3 py-2 rounded-lg bg-slate-950 border border-slate-800 text-white font-mono text-sm focus:outline-none focus:border-amber-500/50" />
        </div>
        <button
          onClick={send}
          disabled={sending}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-500 hover:bg-amber-400 text-black font-medium disabled:opacity-50"
          data-testid="super-broadcast-send"
        ><Send className="w-4 h-4" /> {sending ? 'Sending…' : 'Send to all tenant admins'}</button>
        {result && (
          <div className="text-sm text-slate-300 bg-slate-950 rounded-lg p-3 border border-slate-800">
            Sent: <span className="text-green-400">{result.sent}</span> · Failed: <span className="text-red-400">{result.failed}</span> · Total: {result.total}
          </div>
        )}
      </div>
    </div>
  );
};

export default SuperBroadcastPage;
